import { getScopeActions } from './scopeActionMap';
import { createScopedDispatchers } from '../../shared/selectHandlers/createScopedDispatchers';

export const selectMachineDispatchHandler = (
  dispatch, scope, name, extraOption, locationIdx, specLocationIdx, machineIdx,
  newSelectedMachine, status
) => {
  const { selectMachineDispatch } = createScopedDispatchers(getScopeActions(scope), 'controller');
  selectMachineDispatch(dispatch, name, extraOption, locationIdx, specLocationIdx, machineIdx, newSelectedMachine, status);
};
